export default "__VITE_ASSET__0D7O2BC0__"